import * as React from "react"

const Menu = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    shapeRendering="crispEdges"
    {...props}
  >
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" d="M1 4h14M1 12h14" />
  </svg>
)

export default Menu
